import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DealsWizardModel, DealTermModel } from '../../../../_models/_index';
import { GeneralService } from '../../../../services/_index';
import { DealStepEnum, ViewModeEnum, AlertDialogTypeEnum } from '../../../../_enums/_index';
import { DealTermsItemDialogComponent } from '../deal-terms-item-dialog/deal-terms-item-dialog.component';

@Component({
    selector: 'app-deal-terms-grid',
    templateUrl: './deal-terms-grid.component.html',
    styleUrls: ['./deal-terms-grid.component.css']
})
export class DealTermsGridComponent implements OnInit {
    @Input()
    dealsWizard: DealsWizardModel;
    cols: any[];

    constructor(private dialog: MatDialog,
        private generalService: GeneralService
    ) {
        
    }

    ngOnInit() {
        this.cols = [
           
            { field: 'id', header: '', formatCell: "buttons" , width: '23%' },
            { field: 'description', header: '', formatCell: "none",  width: '48%' },
            { field: 'isBold', header: 'מודגש?', formatCell: "checkbox",  width: '17%' },
             { field: 'id', header: '', formatCell: "reorder", width: '12%' }
        ];
    }

    getMaxTermID() {
        let id = 0;
        this.dealsWizard.terms.forEach(dsi => {
            if (dsi.id > id)
                id = dsi.id;
        });
        return id + 1;
    }

    openAddDealTermDialog() {
        let dialogRef = this.dialog.open(DealTermsItemDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.dialogHeader = 'הוספת הערה';
        dialogRef.componentInstance.viewMode = ViewModeEnum.Add;
        dialogRef.afterClosed().subscribe((result: DealTermModel) => {
            if (result) {
                let copy = Object.assign([], this.dealsWizard.terms);
                result.id = this.getMaxTermID();
                copy.push(result);
                this.dealsWizard.terms = copy;
                this.generalService.setIsDirty('true');
            }
        });
    }

    openEditDealTermDialog(term: DealTermModel) {
        let dialogRef = this.dialog.open(DealTermsItemDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.dialogHeader = 'עריכת הערה';
        dialogRef.componentInstance.viewMode = ViewModeEnum.Edit;
        let term2edit: DealTermModel = new DealTermModel();
        term2edit = Object.assign({}, <DealTermModel>term);
        dialogRef.componentInstance.dealTerms = term2edit;
        dialogRef.afterClosed().subscribe((result: DealTermModel) => {
            if (result) {
                let copy = Object.assign([], this.dealsWizard.terms);
                copy.splice(this.dealsWizard.terms.findIndex(c => c.id == result.id), 1, result);
                this.dealsWizard.terms = copy;
                this.generalService.setIsDirty('true');
            }
        });
    }

    deleteDealTerm(term: DealTermModel) {
        this.generalService.showConfirmDialog("האם למחוק את התנאי '"+term.description+"'?").then(res => {
            if (res) 
            {
                let copy = Object.assign([], this.dealsWizard.terms);
                copy.splice(this.dealsWizard.terms.findIndex(c => c.id == term.id), 1);
                this.dealsWizard.terms = copy;
                this.generalService.setIsDirty('true');
            }
        });
        
    }
}



// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-package/deal-terms-grid/deal-terms-grid.component.ts